import { ProjectComponent } from './project.component';
import { ProjectDetailComponent } from './project-detail.component';
import { PendingChangesGuard } from '../shared/core/pending-changes.guard';
import { RoleGuard } from '../shared/core/role-guard.service';
import { ProjectListComponent } from './project-list/project-list.component';

export const routes = [
    {
        path: 'projectdetail',
        component: ProjectDetailComponent,
        canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE] },
        canDeactivate: [PendingChangesGuard]
      },
      {
        path: 'projectdetail/:projectId',
        component: ProjectDetailComponent,
        canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE] },
        canDeactivate: [PendingChangesGuard]
      },
      {
        path: 'projects',
        component: ProjectListComponent,
        canActivate: [RoleGuard], data: { roles: [process.env.CLEARANCE_ROLE] }
      },
];



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./src/app/project/project.routes.ts